import { Box, Typography, List, ListItem } from '@mui/material'

export default function ProfileEligibilitySummary({ eligibility }) {
  return (
    <Box mb={3}>
      <Box p={3} border={1} borderColor="grey.300" borderRadius={2} mb={1}>
        Profile ID: <strong>{eligibility.id || 'None'}</strong> - Eligible:{' '}
        <strong>{eligibility.is_eligible ? 'YES' : 'NO'}</strong>
        <List>
          {eligibility.requirements_result.map((req, idx) => (
            <ListItem key={idx}>
              {req.name}:{' '}
              <strong>
                {req.is_eligible ? 'MEETS!' : req.ineligible_reasons.join(', ')}
              </strong>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  )
}
